import { Typography } from "@mui/material"
import { useCallback, useState } from "react"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"

import { ResourceTypeCard } from "./ResourceTypeCard"
import { UsageCard } from "./UsageCard"
import type { ResourceTypeGroupViewModel } from "./tenantUsageViewModel"

const useStyles = makeStyles()((theme) => ({
    empty: {
        padding: "2rem",
        textAlign: "center",
        color: theme.palette.tailwind.slate[500],
    },
}))

type ResourceUsageSectionsProps = Readonly<{
    groups: ReadonlyArray<ResourceTypeGroupViewModel>
}>

export function ResourceUsageSections({ groups }: ResourceUsageSectionsProps) {
    const { classes } = useStyles()
    // Expanded state is shared across cards (resource ids are unique across types).
    const [expandedIds, setExpandedIds] = useState<ReadonlySet<number>>(() => new Set<number>())

    const toggle = useCallback((resourceId: number) => {
        setExpandedIds((prev) => {
            const next = new Set(prev)
            if (next.has(resourceId)) {
                next.delete(resourceId)
            } else {
                next.add(resourceId)
            }
            return next
        })
    }, [])

    if (groups.length === 0) {
        return (
            <UsageCard>
                <LocalizedStrict id="service-center-usage-per-tenant-empty-resources">
                    <Typography className={classes.empty}>No resource usage for the selected filters.</Typography>
                </LocalizedStrict>
            </UsageCard>
        )
    }

    return (
        <>
            {groups.map((group) => (
                <ResourceTypeCard key={group.resourceType} group={group} expandedIds={expandedIds} onToggle={toggle} />
            ))}
        </>
    )
}
